import React from 'react';
import {Typography} from "@bonprix/design-system";

export const ItemContent = ({text}) => {
    return (
        <div className={"side-selection-details-content"}>
            <Typography variant={"body1"}>{text}</Typography>
        </div>
    );
};